<template>
<div class="tw_dashboard_process" :class="{edit: isEditMode, disabled: isDisabled}">
  <tw-table-system :schemas="schemas" :height="269" :nopager="true" :items="items" @row-click="rowClick" />
  <!-- <tw-entity-buttons v-if="!isEditMode" size="large" /> -->
</div>
</template>

<script>
import _ from 'lodash';
import { $api } from '@/store/ApiClient';
// import TwEntityButtons from '@/components/molecules/TwEntityButtons';
import TwTableSystem from '@/components/organisms/TwTableSystem';
import schemas from '@/dictionaries/dashBoardProcessListSchema.json';

export default {
  name: 'TwDashBoardProcess',
  props: {
    isEditMode: Boolean,
    isDisabled: Boolean,
  },
  components: {
    // TwEntityButtons,
    TwTableSystem,
  },
  data() {
    return {
      schemas: schemas,
      items: null,
    }
  },
  computed: {
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      // bff_db_1 ダッシュボードプロセス一覧取得
      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/dashboard/process',
        }
      };

      $api
        .request(params)
        .then(res => {
          this.items = res.tradingFlowList.slice(0, 10);
        })
        .catch(err => {
          this.items = [];
          this.$store.dispatch('SHOW_ALERT', err.message);
        });
    },
    rowClick(row) {
      this.$router.push({
        name: `Process${_.capitalize(row.processId.replace(/\d/g, ''))}`,
        params: { entityId: row.entityId, processSeq: row.processSeq, _processId: row.processId.toLowerCase() },
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .tw_dashboard_process {
    position: relative;
    z-index: 2;

    &.edit {
      pointer-events: none;

      &.disabled:after {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(249, 249, 253, 0.5);
        border-radius: 8px;
        content: '';
      }
    }
  }
</style>